import type { Meta, StoryFn } from '@storybook/react';
import type { InfoBannerProps } from 'components/InfoBanner';

import { InfoBanner } from 'components/InfoBanner';

const codeString = `<InfoBanner iconName={string} content={ReactNode} />`;

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/InfoBanner',
  component: InfoBanner,
  argTypes: {},
  parameters: {
    inspectComponent: InfoBanner,
    codeString: codeString,
  },
} as Meta<InfoBannerProps>;

const Template: StoryFn<InfoBannerProps> = (args) => <InfoBanner {...args} />;

export const InfoBannerExample = Template.bind({});
InfoBannerExample.args = {
  content: (
    <span>
      Je voert de roosterwensen in voor <strong>vakaanbieding 2.</strong>
    </span>
  ),
  iconName: 'CalendarEdit',
};
